export const NL: Record<string, string> = {
  Home: "Home",
  "Resource Selected": "Geselecteerde bron",
  "Resources List": "Bronnenlijst",
  List: "Lijst",
  Resources: "Bronnen",
  "Find Colleague": "Zoek collega",
  Settings: "Instellingen",
  "Floor Plan": "Plattegrond",
  Locations: "Locaties",
  Categories: "Categorieën",
  "Search resource name...": "Zoek bronnaam...",
  Calendar: "Kalender",
  "View Details": "Bekijk details",
  "Add to My Favorites": "Toevoegen aan Mijn Favorieten",
  Remove: "Verwijderen",
  "Resource calendar": "Bronkalender",
  Today: "Vandaag",
  "Previous month": "Vorige maand",
  "Next month": "Volgende maand",
  "Previous year": "Vorig jaar",
  "Next year": "Volgend jaar",
  Close: "Sluiten",
  "Field is required.": "Veld is verplicht.",
  "Invalid date format.": "Ongeldig datumformaat.",
  S: "Zo",
  M: "Ma",
  T: "Di",
  W: "Wo",
  F: "Vr",
  January: "Januari",
  February: "Februari",
  March: "Maart",
  April: "April",
  May: "Mei",
  June: "Juni",
  July: "Juli",
  August: "Augustus",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "December",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mrt",
  Apr: "Apr",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dec",
  st: ".",
  nd: ".",
  rd: ".",
  th: ".",
  Sunday: "Zondag",
  Monday: "Maandag",
  Tuesday: "Dinsdag",
  Wednesday: "Woensdag",
  Thursday: "Donderdag",
  Friday: "Vrijdag",
  Saturday: "Zaterdag",
  Sun: "Zo",
  Mon: "Ma",
  Tue: "Di",
  Wed: "Wo",
  Thu: "Do",
  Fri: "Vr",
  Sat: "Za",
  Su: "Zo",
  Mo: "Ma",
  Tu: "Di",
  We: "Wo",
  Th: "Do",
  Fr: "Vr",
  Sa: "Za",
  PM: "PM",
  AM: "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "U kunt deze bron niet boeken omdat uw vergaderverzoek in strijd is met de boekingsregels van de bron.",
  "You need permissions to interact with this resource.":
    "U heeft toestemming nodig om met deze bron te kunnen interacteren.",
  Reason: "Reden",
  "The resource cannot be booked {{day}} days in advanced.":
    "De bron kan niet worden geboekt {{day}} dagen vooruit.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "De einddatum van een terugkerende vergadering kan niet meer dan {{day}} dagen van vandaag zijn.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Vergaderduur mag niet langer zijn dan {{time}} minuten.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Vergaderduur mag niet korter zijn dan {{time}} minuten.",
  "Booking policy": "Boekingsbeleid",
  Available: "Beschikbaar",
  Selected: "Geselecteerd",
  Booked: "Geboekt",
  Closed: "Gesloten",
  "Filter Options": "Filteropties",
  "{{resource}} is deleted": "{{resource}} is verwijderd.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Deze bron kan worden geboekt, maar alle voorkomende conflicten zullen niet worden geboekt.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Deze bron kan van tevoren worden geboekt voor maximaal {{day}} dagen, alle voorkomende gebeurtenissen die deze limiet overschrijden, zullen niet worden geboekt",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Deze bron kan worden geboekt, maar de vergaderduur moet minimaal {{time}} minuten zijn.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Deze bron kan worden geboekt, maar de vergaderduur mag niet langer zijn dan {{time}} minuten.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Het boeken van deze bron vereist goedkeuring van de gedelegeerde van de bron. Uw verzoek wordt doorgestuurd en wacht op goedkeuring.",
  "Resource Name": "Bronnaam",
  Description: "Omschrijving",
  "Resource Mail": "Bronmail",
  Location: "Locatie",
  Capacity: "Capaciteit",
  Language: "Taal",
  "Select an language": "Selecteer een taal",
  "Date/Time Format": "Datum/tijdformaat",
  "First day of the week": "Eerste dag van de week",
  "Please select a first day": "Selecteer een eerste dag",
  "Please select a time format": "Selecteer een tijdformaat",
  "Date Format": "Datumformaat",
  "Please select a date format": "Selecteer een datumformaat",
  "Date Separator": "Datumseparator",
  "Please select a date separator": "Selecteer een datumseparator",
  Apply: "Toepassen",
  "Default Location": "Standaardlocatie",
  Clear: "Wissen",
  Help: "Help",
  "Unavailable": "Niet beschikbaar",
  "No data available": "Geen gegevens beschikbaar",
  "More": "Meer",
  "Available Floor Plans": "Beschikbare plattegronden",
  "Default Categories": "Standaardcategorieën",
  "List more Resources": "Meer bronnen weergeven",
  Attendees: "Deelnemers",
  "Click on Further information to visit our support site":
    "Klik op Meer informatie om onze ondersteuningssite te bezoeken",
    "New Order": "Nieuwe bestelling",
    "Save default categories successfully": "Standaardcategorieën succesvol opgeslagen",
      "Save config date/time successfully": "Datum/tijd configuratie succesvol opgeslagen",
      "Save language successfully": "Taal succesvol opgeslagen",
      "Save default location successfully": "Standaardlocatie succesvol opgeslagen",
      "And": "En",
  "Or": "Of",
  "Available occurrences of the series": "Beschikbare voorkomens van de serie",
  "Conflicting Occurrences": "Conflicterende voorkomens",
  "Availability": "Beschikbaarheid",
  "Time Format": "Tijdformaat",
  "You do not have permission to book this resource.": "U heeft geen toestemming om deze bron te boeken.",
"This resource does not allow booking of recurring meetings.": "Deze bron staat geen boeking van terugkerende vergaderingen toe.",
"You cannot book this resource.": "U kunt deze bron niet boeken."
};
